import { hotRanking } from '@/mocks/comics';

const rankColors = [
  'bg-accent-500 text-background-50',
  'bg-primary-500 text-background-50',
  'bg-secondary-500 text-foreground-900',
  'bg-background-300 text-foreground-700',
  'bg-background-300 text-foreground-700',
  'bg-background-300 text-foreground-700',
];

function formatLikes(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return `${n}`;
}

export default function HotRanking() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20" aria-labelledby="hot-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-fire-fill text-accent-500" aria-hidden="true"></i>
              今日热门
            </span>
            <h2 id="hot-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              全网都在追的热榜
            </h2>
          </div>
          <span className="hidden items-center gap-1 text-sm text-foreground-500 md:flex">
            <i className="ri-time-line" aria-hidden="true"></i>
            每小时实时更新
          </span>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-5" aria-label="今日热门榜单">
          {hotRanking.map((c, i) => (
            <li
              key={c.id}
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-1 hover:border-primary-300 hover:shadow-soft md:p-4"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-lg ${rankColors[i]}`}
              >
                {i + 1}
              </span>
              <img
                src={c.cover}
                alt={`${c.title} 搞笑漫画封面`}
                className="h-20 w-14 shrink-0 rounded-lg object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-base text-foreground-950">
                  <a href="#comics" className="hover:text-primary-600">
                    {c.title}
                  </a>
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-500">
                  {c.categoryName} · 作者 {c.author}
                </p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
                    {formatLikes(c.likes)} 热度
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-play-list-line" aria-hidden="true"></i>
                    {c.chapters} 话
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}